module.exports = __webpack_public_path__ + "assets/img/img165.61e0dcdf.png";